
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { GridMetadata } from "@tylertech/tyler-api-types";

/**
 * ItemDistributionService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemDistributionService<TDistribution = unknown, TItem = unknown> {
    constructor(private readonly $apiService: ApiService) { }
    
    CreateNewDistribution(pItem: TItem): Promise<TDistribution> {
        return this.$apiService.sendAuth("IItemDistributionService/CreateNewDistribution", pItem);
    }
    GetAccountNumber(accountId: string): Promise<string> {
        return this.$apiService.sendAuth("IItemDistributionService/GetAccountNumber", accountId);
    }
    GetDepartmentName(departmentID: string): Promise<string> {
        return this.$apiService.sendAuth("IItemDistributionService/GetDepartmentName", departmentID);
    }
    GetDistributionsByReq(reqId: string): Promise<TDistribution[]> {
        return this.$apiService.sendAuth("IItemDistributionService/GetDistributionsByReq", reqId);
    }
    GetGLImportedItemDistributionTableMetadata(): Promise<GridMetadata> {
        return this.$apiService.sendAuth("IItemDistributionService/GetGLImportedItemDistributionTableMetadata");
    }
    GetGLItemDistributionTableMetadata(): Promise<GridMetadata> {
        return this.$apiService.sendAuth("IItemDistributionService/GetGLItemDistributionTableMetadata");
    }
    GetImportedDistributionsByReq(reqId: string): Promise<TDistribution[]> {
        return this.$apiService.sendAuth("IItemDistributionService/GetImportedDistributionsByReq", reqId);
    }
    GetPurchasedByName(purchasedById: string): Promise<string> {
        return this.$apiService.sendAuth("IItemDistributionService/GetPurchasedByName", purchasedById);
    }
    GetVendorName(vendorId: string): Promise<string> {
        return this.$apiService.sendAuth("IItemDistributionService/GetVendorName", vendorId);
    }
    UpdateAccount(accountId: string): Promise<string[]> {
        return this.$apiService.sendAuth("IItemDistributionService/UpdateAccount", accountId);
    }
}
